export default __webpack_public_path__ + "static/bg-6c50975b9fbb4ea78fbb21ae22f99775.jpg";